import { LitElement, html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes, FontWeights } from '../../../../types/common/types';
import { GzCheckboxWebComponent } from '../../../../ui/gzCheckbox';

export class ActivateCompanyConfirmationWebComponent extends LitElement {
  @property({ type: Number, reflect: true })
  suspendedCompaniesCount;

  @property({ type: Number, reflect: true })
  suspendedPartnerCompaniesCount;

  @query('#activate-recursive-toggle')
  recursiveToggle: GzCheckboxWebComponent;

  public translateFn: (string) => string;

  protected render() {
    return html`
      <div>
        <gz-text id="activate-company-info-text" fontSize=${FontSizes.HEADING_6} fontWeight=${FontWeights.NORMAL}>
          ${this.suspendedCompaniesCount === 1
            ? this.translateFn(
                "The company's users will now be able to log in and its managed endpoints will be protected."
              )
            : this.translateFn(
                "The companies' users will now be able to log in and their managed endpoints will be protected."
              )}
        </gz-text>

        ${this.suspendedPartnerCompaniesCount > 0
          ? html`<gz-checkbox
                label="${this.translateFn('Activate all companies under this company as well.')}"
                id="activate-recursive-toggle"
              >
              </gz-checkbox>
              <gz-text fontSize=${FontSizes.PARAGRAPH_12} class="activate-recursive-text">
                ${this.translateFn('This option will apply recursively.')}
              </gz-text>`
          : ''}
      </div>
    `;
  }

  static get styles() {
    return styles;
  }
}
